const baseUrl = process.env.REACT_APP_SERVER_URI ?? 'http://localhost:4000';
const normalizedBaseUrl = baseUrl.replace(/\/$/, '');
const AUTH_STORAGE_KEY = 'pninit-user-session';

const buildUrl = (path) => `${normalizedBaseUrl}${path.startsWith('/') ? path : `/${path}`}`;

const getStoredSessionToken = () => {
  if (typeof window === 'undefined') return '';
  try {
    return JSON.parse(window.localStorage.getItem(AUTH_STORAGE_KEY) || 'null')?.session?.token || '';
  } catch {
    return '';
  }
};

const buildAuthHeaders = () => {
  const token = getStoredSessionToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const requestJson = async (url, options = {}) => {
  const response = await fetch(url, options);
  const payload = await response.json().catch(() => ({}));

  if (!response.ok || !payload.success) {
    const error = new Error(payload.message ?? `Request failed with status ${response.status}`);
    error.statusCode = response.status;
    throw error;
  }

  return payload.data;
};

export const searchIngredients = (query, signal) => {
  if (!query || !query.trim()) return Promise.resolve([]);
  return requestJson(
    buildUrl(`/api/ingredients?search=${encodeURIComponent(query.trim())}`),
    { headers: { ...buildAuthHeaders() }, signal }
  );
};

export const submitIngredient = (name, signal) =>
  requestJson(buildUrl('/api/ingredients'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...buildAuthHeaders() },
    body: JSON.stringify({ name }),
    signal,
  });
